import { render } from "./VentasPorHoraView.vue?vue&type=template&id=b5c21a70&scoped=true"
import script from "./VentasPorHoraView.vue?vue&type=script&lang=js"
export * from "./VentasPorHoraView.vue?vue&type=script&lang=js"

import "./VentasPorHoraView.vue?vue&type=style&index=0&id=b5c21a70&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c21a70"]])

export default __exports__